import Vue from 'vue'
import { Formatter } from '@/filters/formatter'
Vue.filter('datetime', Formatter.datetime)
